// extracted by mini-css-extract-plugin
export default {"slider-button-wrap":"InputSlideButton_slider-button-wrap__lTlZ9"};